import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { Component, Input, OnInit } from '@angular/core';
import SlotFirstPageModel from '../../models/slot-first-page.model';
import { LoadersService } from '../../utils/loaders/loaders.service';
import { LoaderActions } from '../../utils/loaders/loader-actions.enum';
import { LoaderManagement } from '../../utils/loaders/loader-management';
import AuthProcessSwitcherService from '../auth/auth-process-switcher.service';
import { OptionalMemberService } from '../../cart-process/optional-member.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { BundleDetailsModalService } from '../../services/bundle-details-modal.service';
import { ProcessTypeEnum } from '../../models/cartDetails/process-type.enum';
import { BundleTypeEnum } from '../../models/cartDetails/bundle-type.enum';
import DrawingNewNumberService from '../draw-number/drawing-new-number.service';
import { FormFieldsMasks } from '../../customer-form/field-mask/form-fields-masks';
import { TrafficTypeEnum } from '../../models/cartDetails/trafficType.model';
import { FormGroup } from '@angular/forms';
import { ServiceTypeEnum } from '../../models/cartDetails/service-type.enum';

@Component({
  selector: '[new-offer-slot]',
  templateUrl: './new-offer-slot.component.html',
})
export default class NewOfferSlotComponent implements OnInit {
  public loaderText = '';
  public showRadioSection = false;
  public showDeviceDeleteButton: boolean;
  public showDeviceChangeButton: boolean;
  public isSolo = false;
  public isMnp: boolean;
  public serviceType: ServiceTypeEnum;
  public showProcessInput: boolean;
  public validationMasks = new FormFieldsMasks();
  public isDetailsLinkVisible = false;
  public slotFactory: AuthProcessSwitcherService;
  public isVirginBrand = false;
  protected slotOfferForm: FormGroup;
  private isRemovalOptionalMember = false;

  @Input() public slot: SlotFirstPageModel;

  protected readonly ServiceTypeEnum = ServiceTypeEnum;

  constructor(
    public commonInfo: CommonInfoService,
    private optionalMemberService: OptionalMemberService,
    private loadersService: LoadersService,
    private bundleDetailsModalService: BundleDetailsModalService,
    private drawingNewNumberService: DrawingNewNumberService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
  }

  ngOnInit(): void {
    const isRetention = this.slot.processType === ProcessTypeEnum.RETENTION;
    const isAdditionalVoiceOffer = this.slot.bundleType === BundleTypeEnum.ADDITIONAL_OFFER && this.slot.trafficType === TrafficTypeEnum.VOICE;
    const isPrepaidToPostpaidFirstSlot = this.slot.processType === ProcessTypeEnum.PREPAID_2_POSTPAID && this.slot.slotNo === 1;
    this.isSolo = this.commonInfo.isSolo;
    this.isMnp = this.slot.processType === ProcessTypeEnum.MNP;
    const isSoloNonTvOffer = this.isSolo && !this.slot.isTvOffer;
    this.serviceType = this.slot.serviceType;

    this.slotFactory = new AuthProcessSwitcherService(this.slot);
    this.showProcessInput = isSoloNonTvOffer || isRetention || isAdditionalVoiceOffer || isPrepaidToPostpaidFirstSlot;
    this.showRadioSection = !(this.slot.isTvOffer || this.isSolo || isRetention || isAdditionalVoiceOffer || isPrepaidToPostpaidFirstSlot);
    this.showDeviceDeleteButton =  this.slot.hasNoHandsetOffer && this.slot.possibleChangeDevice;
    this.showDeviceChangeButton = this.slot.possibleChangeDevice;
    this.isDetailsLinkVisible = this.slot.device?.bundledDevice;
    this.isVirginBrand = this.commonInfo.isVirginBrand;

    this.registerLoader();

    if (this.isMnp) {
      this.formsGenerator.setFirstStepActiveForm();
      this.slotOfferForm = this.formsGenerator.activeForm;
    }

    this.formsGenerator.watchActiveForm().subscribe(form => {
      this.slotOfferForm = form;
    });
  }

  public showDetails($event: Event): void {
    $event.preventDefault();

    const deviceId = this.slot.device.sku;
    const msisdn = this.slot.getMsisdn();

    this.bundleDetailsModalService.showDetailsModal(deviceId, msisdn);
  }

  public removeOptionalMember(): void {
    this.isRemovalOptionalMember = true;

    this.optionalMemberService.removeOptionalMember(this.slot)
      .then(() => {
        this.isRemovalOptionalMember = false;
      });
  }

  public removeOptionalMemberConfirmation($event: Event): void {
    $event.preventDefault();

    this.optionalMemberService.numberDeleteConfirmation(this.slot)
      .then(() => {
        this.removeOptionalMember();
      });
  }

  public selectNewNumber($event: Event): void {
    $event.preventDefault();

    this.drawingNewNumberService.selectNewNumber(this.slot);
  }

  public changeProcessType(): void {
    this.clearEditStates();
    this.slotFactory.switchEditStates();

    if (this.slot._computedFields.tempState.MNP_EDIT_STATE) {
      this.formsGenerator.setFirstStepActiveForm();
      this.slotOfferForm = this.formsGenerator.activeForm;
    } else {
      this.formsGenerator.resetActiveForm();
    }
  }


  public changeProcessToMNP($event: Event): void {
    $event.preventDefault();

    if (!this.slotOfferForm.valid) {
      this.formsGenerator.checkActiveFormValidation(this.slotOfferForm);
      return;
    }

    let resolve, reject;

    new Promise((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
    }).then(() => {

    }).catch(() => {
      ($event.target as HTMLAnchorElement).focus();
    });

    this.slotFactory.changeProcessToMNP(resolve, reject);
  }

  private registerLoader(): void {
    const loaderName = LoaderActions.SLOT_LOADER + this.slot.slotNo;

    this.loadersService
      .registerLoader(loaderName, [LoaderActions.SUMMARY_PRICES_LOADER])
      .subscribe((context: LoaderManagement) => {
        if (this.isRemovalOptionalMember) {
          this.loaderText = 'Usuwamy numer z koszyka';
        } else {
          this.loaderText = 'Wprowadzamy zmiany dla tego numeru';
        }

        this.slot.isLoaderVisible = context.visible;
      });
  }

  private clearEditStates(): void {
    this.slotFactory.clearEditStates();

    this.slotOfferForm?.reset();
    const slotTile = document.getElementById('slot-' + this.slot.ordinal);
    slotTile.getElementsByClassName('form-input')[0]?.classList.remove('success', 'error');
    slotTile.querySelector('[role="alert"]')?.remove();
  }
}
